import * as React from "react";
import {DateRangePicker, DropdownMenuProps, TextInputProps, TimePicker, TimePickerProps} from "@vebox/etui-core";
import {MILLISECONDS_IN_A_HOUR, MILLISECONDS_IN_A_MINUTES} from "./utils";
import {DateRangePickerProps} from "@vebox/etui-core/ts/DateRangePicker/DateRangePicker.types";

interface DateTimePickerProps {
    onChange?: React.ChangeEventHandler<{ value: number }>;
    datePickerStyles?: DateRangePickerProps['styles']
    timePickerStyles?: TextInputProps['styles']
    timePickerMenuProps: Partial<DropdownMenuProps>;
    containerClassName?: string
    timePickerLabels?: TimePickerProps['labels']
    datePickerLabel?: string
}

export function DateTimePicker({
                                   onChange,
                                   timePickerStyles,
                                   datePickerStyles,
                                   containerClassName,
                                   timePickerMenuProps,
                                   timePickerLabels,
                                   datePickerLabel
                               }: DateTimePickerProps) {
    const [timeInMilliseconds, setTimeInMilliseconds] = React.useState<number>(0);
    const [dateInMilliseconds, setDateInMilliseconds] = React.useState<number>(0);

    const now = new Date();
    const [startDate, setStartDate] = React.useState<Date>(now);


    function extractDate({startDate: newStartDate}: { startDate: Date }) {
        const newStartDateWithoutTime = new Date(
            newStartDate.getFullYear() + '/' + (newStartDate.getMonth() + 1) + '/' + newStartDate.getDate());
        setDateInMilliseconds(newStartDateWithoutTime.getTime());
        setStartDate(newStartDateWithoutTime);
    }

    function extractTime(timestr: string) {
        const [hoursStr, minutesStr, secondsStr] = timestr.split(":");
        const hours = Number.parseInt(hoursStr);
        const minutes = Number.parseInt(minutesStr);
        const seconds = Number.parseInt(secondsStr);
        if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
            return;
        }
        setTimeInMilliseconds(hours * MILLISECONDS_IN_A_HOUR + minutes * MILLISECONDS_IN_A_MINUTES + seconds * 1000);
    }

    React.useEffect(() => {
        const timestamp = dateInMilliseconds + timeInMilliseconds;
        onChange?.({
            target: {
                value: timestamp !== 0 ? timestamp : (new Date()).getTime(),
            },
        } as any);
    }, [dateInMilliseconds, timeInMilliseconds]);

    React.useEffect(() => {
        extractTime(`${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`);
        extractDate({startDate: now})
    }, [])

    return (
        <div className={containerClassName}>
            <DateRangePicker
                label={datePickerLabel ?? "Date"}
                startDate={startDate}
                onChange={extractDate}
                disableRange={true}
                styles={datePickerStyles}
            />
            <div>
                <TimePicker
                    labels={timePickerLabels ?? {main: "Time"}}
                    onChange={extractTime}
                    styles={timePickerStyles}
                    dropdownProps={timePickerMenuProps}
                    defaultValue={`${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`}
                />
            </div>
        </div>
    );
}